import type { FormControlType, FormElement } from '@common/types/form-element.type';

import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import * as typeGuards from '@common/type-guards/form-elements.type-guards';
import { defaultFormElements } from '@common/constants/form-element.const';

@Injectable({
    providedIn: 'root',
})
export class FormElementService {
    private readonly translate = inject(TranslateService);

    public getDefaultElement(type: FormControlType | string): FormElement {
        const template = defaultFormElements.get(type === 'multiselect' ? 'select' : type);
        const element = structuredClone(template);
        element.label = this.translate.instant(element.label);
        if (typeGuards.isInput(element) || typeGuards.isTextarea(element)) {
            element.placeholder = this.translate.instant(element.placeholder);
        }

        if (typeGuards.isRadio(element) || typeGuards.isSelect(element)) {
            const label = this.translate.instant('form_radio_option');
            const value = this.translate.instant('form_radio_value');

            element.htmlInputType = type as any;
            element.options = [...Array(2).keys()].map((i) => ({
                label: `${label} ${i}`,
                value: `${value} ${i}`,
                selected: i === 0,
            }));
        }
        return element;
    }
}
